<template>
    <div class="app">
        <div class="title">
            <div class="dis">
                <div class="title_text title_text2" @click="back">项目管理 ></div>
                <div class="title_text">资料管理</div>
            </div>
        </div>

        <!-- Tab切换 -->
        <div class="tab-container">
            <div class="custom-tabs">
                <div class="tab-item" :class="{ active: activeTab === 'projectInfo' }"
                    @click="switchTab('projectInfo')">
                    项目信息
                </div>
                <div class="tab-item" :class="{ active: activeTab === 'publicData' }" @click="switchTab('publicData')">
                    公开资料
                </div>
                <div class="tab-item" :class="{ active: activeTab === 'internalData' }"
                    @click="switchTab('internalData')">
                    内部资料
                </div>
            </div>
        </div>

        <!-- 项目信息内容 -->
        <div v-if="activeTab === 'projectInfo'" class="project-info-content">
            <div class="info-grid">
                <div class="info-row">
                    <div class="info-item">
                        <span class="label">合同编号：</span>
                        <span class="value">{{ obj.contractNumber }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">项目名称：</span>
                        <span class="value">{{ obj.projectName }}</span>
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-item">
                        <span class="label">客户名称：</span>
                        <span class="value">{{ obj.customerName }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">合同金额：</span>
                        <span class="value">￥{{ obj.contractAmount }}</span>
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-item">
                        <span class="label">负责人：</span>
                        <span class="value">{{ obj.responsiblePerson }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">到期时间：</span>
                        <span class="value">{{ obj.expirationTime }}</span>
                    </div>
                </div>
                <div class="info-row">
                    <div class="info-item">
                        <span class="label">合同附件：</span>
                        <div v-if="obj.attachmentUrl" class="dis" style="margin-right: 20rem;cursor: pointer;"
                            @click="down_file2()">
                            <img src="../../assets/74.png" class="i74" alt="">
                            <div>{{ file_name }}</div>
                        </div>
                        <el-button type="text" class="upload-btn dis" @click="selectImg"><img src="../../assets/73.png"
                                class="i73" alt="">
                            上传附件</el-button>
                        <input type="file" id="filed_page" hidden @change="filePreview" />
                    </div>
                    <div class="info-item">
                        <span class="label">项目状态：</span>
                        <span class="value status-active" v-if="obj.projectStatus == 1">保修中</span>
                        <span class="value status-active status2" v-if="obj.projectStatus == 2">已过期</span>
                    </div>
                </div>
                <div class="info-row full-width">
                    <div class="info-item">
                        <span class="label">备注：</span>
                        <span class="value">{{ obj.remarks }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 公开资料和内部资料表格 -->
        <div v-if="activeTab === 'publicData' || activeTab === 'internalData'" class="table_pad">
            <div class="dis" style="margin-bottom: 20px;">
                <el-button class="Add_btn dis_center" type="primary" @click="showAddDialog = true">
                    <div class="dis_center">
                        <img class="img11" src="../../assets/12.png" alt="" />
                        <div>新增文件</div>
                    </div>
                </el-button>
            </div>

            <div class="table">
                <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" stripe
                    :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ textAlign: 'center' }">
                    <el-table-column type="index" label="序号" width="80">
                    </el-table-column>
                    <el-table-column prop="fileName" label="文件名称" min-width="20%">
                    </el-table-column>
                    <el-table-column prop="fileUri" label="文件路径" min-width="40%">
                    </el-table-column>
                    <el-table-column prop="operation" label="操作" min-width="15%">
                        <template slot-scope="scope">
                            <div class="dis_center table_btn">

                                <div class="dis" @click="down_file(scope.row)">
                                    <div>下载</div>
                                </div>
                                <el-button type="text" class="delete-btn" @click="deleteFile(scope.row.id)">
                                    删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->

            <div class="page_box">
                <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
                    :current-page.sync="pageNumber" :total="total">
                </el-pagination>
            </div>
        </div>

        <!-- 新增文件弹窗 -->
        <el-dialog title="新增文件" :visible.sync="showAddDialog" width="500px" :before-close="handleCloseDialog">
            <el-form :model="fileForm" :rules="fileRules" ref="fileForm" label-width="100px">
                <el-form-item label="文件名称" prop="fileName">
                    <!-- <el-input v-model="fileForm.fileName" placeholder="请输入文件名称"></el-input> -->
                    <div>{{ fileForm.fileName || '请选择文件' }}</div>
                </el-form-item>
                <el-form-item label="文件" prop="file">
                    <div class="custom-upload">
                        <input type="file" ref="fileInput" @change="handleFileSelect" style="display: none;"
                            accept="*/*" />
                        <el-button size="small" type="primary" @click="$refs.fileInput.click()">
                            选择文件
                        </el-button>
                        <span class="file-info" v-if="selectedFile">
                            已选择: {{ selectedFile.name }} ({{ formatFileSize(selectedFile.size) }})
                        </span>
                        <div class="upload-tip">支持图片、视频、文档等所有格式，文件大小不超过200MB</div>

                        <!-- 文件预览区域 -->
                        <div v-if="filePreviewUrl" class="file-preview">
                            <!-- 图片预览 -->
                            <div v-if="isImage(selectedFile)" class="image-preview">
                                <img :src="filePreviewUrl" alt="预览图片" class="preview-img" />
                            </div>
                            <!-- 视频预览 -->
                            <div v-else-if="isVideo(selectedFile)" class="video-preview">
                                <video :src="filePreviewUrl" controls class="preview-video"></video>
                            </div>
                            <!-- 其他文件类型显示文件信息 -->
                            <div v-else class="file-info-preview">
                                <div class="file-icon">📄</div>
                                <div class="file-details">
                                    <div class="file-name">{{ selectedFile.name }}</div>
                                    <div class="file-size">{{ formatFileSize(selectedFile.size) }}</div>
                                    <div class="file-type">{{ getFileType(selectedFile.name) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">取 消</el-button>
                <el-button type="primary" @click="handleSubmit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from "axios";
import {
    api,
    img_url,
    getProjectContractDetail, editProjectContract, getContractFileMePage, editContractFile, removeContractFile
} from "../js/api";
export default {
    name: 'ProjectInformation',
    data() {
        return {
            activeTab: 'projectInfo',
            showAddDialog: false,
            pageNumber: 1,
            pageSize: 10,
            total: 0,
            tableData: [],
            uploadUrl: api + '/file/upload/10', // 上传接口地址
            uploadUrl2: api + '/file/upload/11', // 上传接口地址
            obj: {},
            // 文件表单数据
            fileForm: {
                fileName: '',
                file: null
            },

            // 新增的文件相关数据
            selectedFile: null,
            filePreviewUrl: null,

            // 文件列表
            fileList: [],

            // 表单验证规则
            fileRules: {
                fileName: [
                    { required: true, message: '请输入文件名称', trigger: 'blur' }
                ],
                file: [
                    { required: true, message: '请选择文件', trigger: 'change' }
                ]
            },

            // 公开资料数据
            publicDataList: [
            ],

            // 内部资料数据
            internalDataList: [
            ],
            id: '',
            file_name: ''
        }
    },
    created() {
        let that = this;
        let id = that.$route.query.id;
        that.id = id;
        that.ajaxload()
    },
    computed: {

        // 当前显示的表格数据
        currentTableData() {
            if (this.activeTab === 'publicData') {
                return this.publicDataList
            } else if (this.activeTab === 'internalData') {
                return this.internalDataList
            }
            return []
        },

        // 上传文件时的请求头，包含token
        uploadHeaders() {
            const token = localStorage.getItem('loginToken')
            return {
                'x-auth-token': token || ''
            }
        }
    },

    mounted() {
        this.updateTotalCount()
    },

    methods: {
        down_file(e) {
            let that = this;
            console.log(img_url + e.fileUri)
            // window.location.href = img_url + "/" + e.fileUri;
            window.open(img_url + e.fileUri)
        },
        down_file2() {
            let that = this;
            // window.location.href = img_url + "/" + e.fileUri;
            window.open(img_url + that.obj.attachmentUrl)
        },
        get_fileList(type) {
            let that = this;
            let json = {
                entityParam: {
                    contractId: that.id,
                    fileType: type
                },
                pageReq: {
                    pageNumber: that.pageNumber,
                    pageSize: that.pageSize,
                }
            };
            getContractFileMePage(json).then((res) => {
                //console.log(res);
                if (res.code == 200) {
                    let data = res.data.records;
                    that.tableData = data;
                    that.total = Number(data.total || 0);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        selectImg(e) {
            this.choose_type = e;
            document.getElementById("filed_page").click();
        },
        filePreview(e) {
            let that = this; //上传前页面显示图片
            console.log(that.choose_type);
            that.url = URL.createObjectURL(e.target.files[0]);
            let formData = new FormData();
            formData.append("file", e.target.files[0]);
            // formData.append("compNo", localStorage.getItem("compNo")); // 通过append向form对象添加数据,上传文件的同时， 也可以上传其他数据
            let config = {
                headers: { "Content-Type": "multipart/form-data" },
            }; //添加请求头
            // return;
            const loading = this.$loading({
                lock: true,
                text: '文件上传中..',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            axios.post(api + "/file/upload/9", formData, config).then((response) => {
                //这里的/xapi/upimage为接口
                if (response.data.code == 200) {
                    // let path = api + "/" + response.data.data;
                    let path = response.data.data;
                    let info = that.obj;
                    console.log(info, path);
                    info.attachmentUrl = path;
                    that.obj = info;
                    loading.close();
                    that.save()
                } else {
                    loading.close();
                    that.$message.error(response.data.message);
                }
            });
        },

        ajaxload() {
            let that = this;
            let json = {
                id: that.id
            }
            getProjectContractDetail({ params: json }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    let data = res.data;
                    let file_name = ''
                    if (data.attachmentUrl) {
                        let arr = data.attachmentUrl.split('original=');
                        console.log(arr)
                        file_name = arr[1]
                    }
                    that.file_name = file_name;
                    that.obj = data;
                } else {
                    this.$message.error(res.message);
                }
            })
        },

        save() {
            let that = this;
            let json = that.obj;
            const loading = this.$loading({
                lock: true,
                text: '资源保存中..',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            editProjectContract(json).then((res) => {
                that.disabled_save = false; loading.close();
                // console.log(res);
                if (res.code == 200) {
                    this.$message({
                        message: "添加成功",
                        type: "success",
                    });
                    that.ajaxload();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        back() {
            this.$router.go(-1)
        },
        // Tab切换处理
        switchTab(tabName) {
            this.activeTab = tabName
            this.updateTotalCount()
        },

        // 更新总数
        updateTotalCount() {
            if (this.activeTab === 'publicData') {
                this.get_fileList(1)
                // this.totalCount = this.publicDataList.length
            } else if (this.activeTab === 'internalData') {
                this.get_fileList(2)
                // this.totalCount = this.internalDataList.length
            } else {
                this.totalCount = 0
            }
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val
        },

        handleCurrentChange(val) {
            this.currentPage = val
        },

        // 关闭弹窗
        handleCloseDialog() {
            this.showAddDialog = false
            this.resetForm()
        },

        // 重置表单
        resetForm() {
            this.$refs.fileForm.resetFields()
            this.fileList = []
            this.selectedFile = null
            this.filePreviewUrl = null
            this.fileForm = {
                fileName: '',
                file: null
            }
            // 清空文件输入框
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = ''
            }
        },

        // 提交表单
        handleSubmit() {
            let that = this;
            this.$refs.fileForm.validate(async (valid) => {
                if (valid) {
                    try {
                        // 先上传文件到服务器
                        const fileUrl = await this.uploadFileToServer()
                        const loading = this.$loading({
                            lock: true,
                            text: '资源保存中..',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)',
                            customClass: "is_loading"
                        });

                        // 添加到对应的数据列表
                        const newFile = {
                            contractId: that.id,
                            fileName: this.fileForm.fileName,
                            fileUri: fileUrl
                        }

                        if (this.activeTab === 'publicData') {
                            newFile.fileType = 1;
                        } else if (this.activeTab === 'internalData') {
                            newFile.fileType = 2;
                        }

                        editContractFile(newFile).then(res => {
                            if (res.code == 200) {
                                loading.close();
                                this.updateTotalCount()
                                this.handleCloseDialog()
                                this.$message.success('文件添加成功')
                            } else {
                                this.$message.error(res.message);
                            }
                        })
                    } catch (error) {
                        loading.close();
                        this.$message.error('文件上传失败: ' + error.message)
                    }
                }
            })
        },

        // 文件选择处理
        handleFileSelect(event) {
            const file = event.target.files[0]
            if (!file) return

            // 文件大小验证 (200MB)
            const maxSize = 200 * 1024 * 1024
            if (file.size > maxSize) {
                this.$message.error('文件大小不能超过200MB!')
                return
            }

            this.selectedFile = file
            this.fileForm.fileName = file.name
            this.fileForm.file = file

            // 创建预览URL
            if (this.isImage(file) || this.isVideo(file)) {
                this.filePreviewUrl = URL.createObjectURL(file)
            } else {
                this.filePreviewUrl = null
            }
            // this.fileForm.file = this.filePreviewUrl
            return
            let formData = new FormData();
            formData.append("file", file);
            // formData.append("compNo", localStorage.getItem("compNo")); // 通过append向form对象添加数据,上传文件的同时， 也可以上传其他数据
            let config = {
                headers: { "Content-Type": "multipart/form-data" },
            }; //添加请求头
            // return;
            let url = api + "/file/upload/10";
            if (this.activeTab == 'internalData') {
                url = api + "/file/upload/11";
            }
            axios.post(url, formData, config).then((response) => {
                //这里的/xapi/upimage为接口
                if (response.data.code == 200) {
                    // let path = api + "/" + response.data.data;
                    let path = response.data.data;

                    this.fileForm.file = path
                } else {
                    that.$message.error(response.data.message);
                }
            });

        },

        // 判断是否为图片
        isImage(file) {
            if (!file) return false
            return file.type.startsWith('image/')
        },

        // 判断是否为视频
        isVideo(file) {
            if (!file) return false
            return file.type.startsWith('video/')
        },

        // 格式化文件大小
        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes'
            const k = 1024
            const sizes = ['Bytes', 'KB', 'MB', 'GB']
            const i = Math.floor(Math.log(bytes) / Math.log(k))
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
        },

        // 获取文件类型
        getFileType(fileName) {
            const extension = fileName.split('.').pop().toLowerCase()
            const typeMap = {
                'pdf': 'PDF文档',
                'doc': 'Word文档',
                'docx': 'Word文档',
                'xls': 'Excel表格',
                'xlsx': 'Excel表格',
                'ppt': 'PowerPoint演示文稿',
                'pptx': 'PowerPoint演示文稿',
                'txt': '文本文件',
                'jpg': '图片文件',
                'jpeg': '图片文件',
                'png': '图片文件',
                'gif': '图片文件',
                'mp4': '视频文件',
                'avi': '视频文件',
                'mov': '视频文件',
                'wmv': '视频文件',
                'zip': '压缩文件',
                'rar': '压缩文件'
            }
            return typeMap[extension] || '未知类型'
        },

        // 上传文件到服务器
        uploadFileToServer() {
            return new Promise((resolve, reject) => {
                if (!this.selectedFile) {
                    reject(new Error('没有选择文件'))
                    return
                }
                const loading = this.$loading({
                    lock: true,
                    text: '文件上传中..',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                    customClass: "is_loading"
                });
                const formData = new FormData()
                formData.append('file', this.selectedFile)

                const uploadUrl = this.activeTab === 'publicData' ? this.uploadUrl : this.uploadUrl2

                axios.post(uploadUrl, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-auth-token': localStorage.getItem('loginToken') || ''
                    }
                }).then(response => {
                    if (response.data.code === 200) {
                        resolve(response.data.data)
                    } else {
                        reject(new Error(response.data.message))
                    }
                }).catch(error => {
                    loading.close();
                    reject(error)
                })
            })
        },

        // 删除文件
        deleteFile(e) {
            let that = this;
            this.$confirm('确认删除该文件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let json = {
                    id: e
                }
                removeContractFile({ params: json }).then(res => {
                    if (res.code == 200) {


                        this.updateTotalCount()
                        this.$message.success('删除成功')
                    } else {
                        this.$message.error(res.message);
                    }
                })

            }).catch(() => {
                // 取消删除
            })
        }
    }
}
</script>

<style scoped>
@import url("../userManagement/userManagement.css");

/* 自定义上传样式 */
.custom-upload {
    width: 100%;
}

.file-info {
    margin-left: 10px;
    color: #666;
    font-size: 12px;
}

.upload-tip {
    margin-top: 8px;
    color: #999;
    font-size: 12px;
}

.file-preview {
    margin-top: 15px;
    padding: 15px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background-color: #fafafa;
}

.image-preview {
    text-align: center;
}

.preview-img {
    max-width: 100%;
    max-height: 200px;
    border-radius: 4px;
}

.video-preview {
    text-align: center;
}

.preview-video {
    max-width: 100%;
    max-height: 200px;
    border-radius: 4px;
}

.file-info-preview {
    display: flex;
    align-items: center;
    padding: 10px;
}

.file-icon {
    font-size: 48px;
    margin-right: 15px;
}

.file-details {
    flex: 1;
}

.file-name {
    font-weight: bold;
    margin-bottom: 5px;
    color: #333;
}

.file-size {
    color: #666;
    font-size: 12px;
    margin-bottom: 3px;
}

.file-type {
    color: #999;
    font-size: 12px;
}

.app {
    padding: 0 20px;
    background-color: #f5f5f5;
    min-height: 100vh;
}

.title {
    cursor: pointer;
    margin-bottom: 20px;
}

.dis {
    display: flex;
    align-items: center;
}

.dis_center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.tab-container {
    background: white;
    padding: 0 20px;
    border-radius: 8px 8px 0 0;
    /* margin-bottom: 20px; */
}

/* 自定义Tab样式 */
.custom-tabs {
    display: flex;
    border-bottom: 1px solid #e4e7ed;
    /* margin-bottom: 20px; */
}

.tab-item {
    padding: 12px 24px;
    cursor: pointer;
    font-size: 14px;
    color: #606266;
    border-bottom: 2px solid transparent;
    transition: all 0.3s ease;
    position: relative;
}

.tab-item:hover {
    color: #409eff;
}

.tab-item.active {
    color: #C1272D;
    border-bottom-color: #C1272D;
    font-weight: 500;
}

.project-info-content {
    background: white;
    padding: 30px;
    border-radius: 8px;
    margin-bottom: 20px;
}

.info-grid {
    max-width: 1000px;
}

.info-row {
    display: flex;
    margin-bottom: 25px;
}

.info-row.full-width {
    flex-direction: column;
}

.info-item {
    flex: 1;
    display: flex;
    align-items: center;
    margin-right: 40px;
}

.info-row.full-width .info-item {
    margin-right: 0;
}

.label {
    color: #666;
    font-size: 14px;
    min-width: 80px;
    margin-right: 10px;
}

.value {
    color: #333;
    font-weight: bold;
    font-size: 14px;
    line-height: 1.5;
}

.status-active {
    padding: 2px 8px;
    background: #E5F9F3;
    color: #00C085;
    font-weight: bold;
}

.upload-btn {
    color: #409EFF;
    padding: 0;
}

.table_pad {
    background: white;
    padding: 20px;
    border-radius: 0 0 8px 8px;
    margin-top: 0;
}

.Add_btn {
    background: #C1272D;
    border: none;
    width: 100px;
    padding: 10px 20px;
    border-radius: 4px;
    color: white;
    font-size: 14px;
}

.img11 {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}

.table {
    margin-top: 20px;
}

.table_btn {
    gap: 10px;
}

.delete-btn {
    color: #F56C6C;
    padding: 0;
}

.page_box {
    margin-top: 20px;
    text-align: right;
}

.dialog-footer {
    text-align: right;
}

.upload-demo {
    width: 100%;
}

/* Element UI 样式覆盖 */
::v-deep .el-tabs__header {
    margin: 0;
}

::v-deep .el-tabs__nav-wrap::after {
    display: none;
}

::v-deep .el-tabs__item {
    padding: 0 30px;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
}

::v-deep .el-tabs__item.is-active {
    color: #409EFF;
    border-bottom: 2px solid #409EFF;
}

::v-deep .el-table th {
    background-color: #fafafa;
}

::v-deep .el-pagination {
    text-align: right;
}

.i73 {
    width: 18rem;
    height: 18rem;
}

.i74 {
    cursor: pointer;
    width: 40rem;
    height: 40rem;
}

.status2 {
    background: #F5F5F5;
    color: #BFBFBF;
}

.is_loading {
    color: white;
}

>>>.el-loading-spinner>.el-loading-spinner .el-loading-text {
    color: white;
}
</style>


// WEBPACK FOOTER //
// src/view/ProjectInformation/ProjectInformation.vue